// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { Picklist } from '../'


export const FilterMessageChannel = ({ title, value, onChange }) => (
  <div className="sidebar__item slds-p-top_medium slds-p-right_large slds-p-bottom_small slds-p-left_large">
    <div className="slds-grid slds-wrap">
      <div className="slds-col slds-size_1-of-1 sidebar__item__title">
        {title}
      </div>
      <div className="slds-col slds-size_3-of-4">
        <div className="sidebar__item__choice">
          <Picklist
            id='messageChannel'
            default='All'
            options={['All', 'Telegram', 'WhatsApp']}
            symbol='chevrondown'
            value={value === ''
               ? 'All'
               : value
            }
            onChange={onChange}
            closeDropdownOnSelect={true}
            inline={true}
          />
        </div>
      </div>
    </div>
  </div>
)

FilterMessageChannel.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

FilterMessageChannel.defaultProps = {
  title: 'Employment type'
}



// WEBPACK FOOTER //
// ./src/components/filter-message-channel/index.js